import Modal from "react-modal";
import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import {
  useAddAssignmentMutation,
  useGetAssignmentQuery,
  useGetAssignmentsQuery,
  useUpdateAssignmentMutation,
} from "@features/assignments/assignmentsApi";
import { useGetVideosQuery } from "@features/videos/videosApi";
import InputWrapper from "@common/components/InputWrapper";

const AssignmentModal = ({ assignmentId = "", open, closeModal }) => {
  const [title, setTitle] = useState("");
  const [video_id, setVideoId] = useState("");
  const [video_title, setVideoTitle] = useState("");
  const [totalMark, setTotalMark] = useState("");

  const { data: assignments } = useGetAssignmentsQuery();

  const [addAssignment, { isLoading }] = useAddAssignmentMutation();

  const [updateAssignment, { isLoading: isUpdateLoading }] =
    useUpdateAssignmentMutation();

  const { data: assignment } = useGetAssignmentQuery(assignmentId);

  const { data: videos } = useGetVideosQuery();

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      transform: "translate(-50%, -50%)",
    },
  };

  Modal.setAppElement("#root");

  useEffect(() => {
    const { title, video_id, video_title, totalMark } = assignment || {};
    if (assignmentId) {
      setTitle(title);
      setVideoId(+video_id);
      setVideoTitle(video_title);
      setTotalMark(+totalMark);
    }
  }, [assignment, assignmentId]);

  const handleSelectChange = (e) => {
    setVideoId(+e.target.options[e.target.selectedIndex].dataset.id);
    setVideoTitle(e.target.options[e.target.selectedIndex].text);
  };

  const resetForm = () => {
    setTitle("");
    setVideoId("");
    setVideoTitle("");
    setTotalMark("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      title,
      video_id,
      video_title,
      totalMark: +totalMark,
    };

    let videoItem = assignments?.find((a) => a.video_title === video_title);

    if (videoItem === undefined) {
      const response = await addAssignment(data);
      if (response?.data) {
        resetForm();
        closeModal();
        toast.success("Assignment added successfully!");
      } else {
        toast.error("Assignment added failed!");
      }
    } else {
      toast.error("Video already added to another assignment!");
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    const data = {
      title,
      video_id,
      video_title,
      totalMark: +totalMark,
    };

    // Check if the selected video is the same as the current assignment's video
    if (
      video_title !== assignments.find((a) => a.id === assignmentId).video_title
    ) {
      let videoItem = assignments?.find((a) => a.video_title === video_title);
      if (videoItem !== undefined) {
        toast.error("Video already added to another assignment!");
        return;
      }
    }

    const response = await updateAssignment({ id: assignmentId, data });
    if (response?.data) {
      closeModal();
      toast.success("Assignment updated successfully!");
    } else {
      toast.error("Assignment updated failed!");
    }
  };

  return (
    <Modal
      isOpen={open}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <h2 className="text-xl text-center font-bold">
        {assignmentId ? "Update" : "Add"} Assignment
      </h2>
      <button className="btn-modal-close" onClick={closeModal}>
        &times;
      </button>
      <form
        className="space-y-6"
        onSubmit={assignmentId ? handleUpdate : handleSubmit}
      >
        <div className="rounded-md shadow-sm -space-y-px">
          <InputWrapper
            id="title"
            name="title"
            type="text"
            required
            className="form-input rounded"
            placeholder="Assignment Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />

          <div style={{ marginBottom: "-7px" }}>
            <label htmlFor="description" className="form-label sr-only">
              Video Title
            </label>
            <select
              name="video_title"
              id="video_title"
              required
              className="form-input rounded"
              value={video_title}
              onChange={handleSelectChange}
            >
              <option value="" disabled>
                Select Video
              </option>
              {videos?.length > 0 &&
                videos.map((video) => (
                  <option key={video.id} value={video.title} data-id={video.id}>
                    {video.title}
                  </option>
                ))}
            </select>
          </div>

          <InputWrapper
            id="totalMark"
            name="totalMark"
            type="text"
            required
            className="form-input rounded"
            placeholder="Total Mark"
            value={totalMark}
            onChange={(e) => setTotalMark(e.target.value)}
          />

          <div className="submit-button-wrapper text-center">
            <button
              type="submit"
              disabled={assignmentId ? isUpdateLoading : isLoading}
              className="btn-submit font-bold w-full"
            >
              Submit
            </button>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default AssignmentModal;
